import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { ConnectedRouter } from 'react-router-redux'

import appHistory from '../util/history'
import UserPage from '../user/UserPage'
import RequestsFocus from '../home/RequestsFocus'
import HomePage from '../home/HomePage'
import CreateRequest from '../serviceDesk/CreateRequest'
import CreateRequestPage from '../home/CreateRequestPage'
import ViewEditRequest from '../serviceDesk/ViewEditRequest'
import CheckAccessStatus from '../accessSelfService/CheckAccessStatus'
import AdminTools from '../admin/admin'

export const routes = [
  { path: '/', title: 'Home', component: HomePage, nav: true },
  { path: '/user', title: 'User', component: UserPage, nav: false },
  { path: '/requests/:issueKey', component: ViewEditRequest, nav: false},
  { path: '/requests', title: 'My Requests',component: RequestsFocus, nav: true },
  { path: '/access', title: 'How User Access Works', component: CheckAccessStatus, nav: false },
  { path: '/createReq', component: CreateRequest, nav: false },
  { path: '/create', title: 'Create a Request', component: CreateRequestPage, nav: true },
  { path: '/admin', title: 'Admin Tools', component: AdminTools, nav: false }
]

export const navRoutes = routes.filter(r => r.nav)

const Routes = ({component, history = appHistory}) => {
  var Component = component
  return (
    <ConnectedRouter history={history}>
      <Component>
        <Switch>
          {routes.map(route => <Route key={route.path} path={route.path} exact component={route.component} />)}
        </Switch>
      </Component>
    </ConnectedRouter>
  )
}

export default Routes



// WEBPACK FOOTER //
// ./client/src/root/routes.js